
export function  mobileValidate(mobile){
    if (/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/.test(mobile)) {
      return true;
    }
    return false;
  }






// WEBPACK FOOTER //
// ./src/api/baseApi.js